import React, { Component } from 'react';
import SRCards from '../../components/SRCards'
import EmailApi from '../../services/email.service'
import {
    Button, Container, FormControlLabel, Grid, IconButton,
    Paper, Snackbar, Switch, TextField, Tooltip, Typography
} from '@material-ui/core';
import InfoIcon from '@material-ui/icons/Info';
import { Alert, Autocomplete } from '@material-ui/lab';
import SelectCompany from '../../components/SelectCompany';
import CompanyApi from '../../services/company.service';
import { MASTER_COMPANY } from '../../common/constants';
import { CHECK_NON_EMPTY_DICTIONARY } from '../../common/data-validator';

type IState = {
    ticketModule: any,
    invoiceModule: any,
    estimateModule: any,
    domainToggle: boolean,   
    snackBar: any,
    pageResponse: any,
    companyList: any,
    selectedItem: any,
    errors: {
        sendFromFirstnameErrorTicket: any,
        sendFromEmailIdErrorTicket: any,
        replyToFirstnameErrorTicket: any,
        replyToEmailIdErrorTicket: any,
        sendFromFirstnameErrorInvoice: any,
        sendFromEmailIdErrorInvoice: any,
        replyToFirstnameErrorInvoice: any,
        replyToEmailIdErrorInvoice: any,
        sendFromFirstnameErrorEstimate: any,
        sendFromEmailIdErrorEstimate: any,
        replyToFirstnameErrorEstimate: any,
        replyToEmailIdErrorEstimate: any,
        bccErrorTicket: any,
        bccErrorInvoice: any,
        bccErrorEstimate: any
    }
}
const apiservices = new EmailApi()
const companyApiServices = new CompanyApi()

class EmailDomainChange extends Component<{}, IState>{
    constructor(props: any) {
        super(props)
        this.state = {
                companyList: [],
                selectedItem: null,
            domainToggle: false,
            ticketModule: {},
            invoiceModule: {},
            estimateModule: {},
            snackBar: '',
            pageResponse: null,
            errors: {
                sendFromFirstnameErrorTicket: '',
                sendFromEmailIdErrorTicket: '',
                replyToFirstnameErrorTicket: '',
                replyToEmailIdErrorTicket: '',
                sendFromFirstnameErrorInvoice: '',
                sendFromEmailIdErrorInvoice: '',
                replyToFirstnameErrorInvoice: '',
                replyToEmailIdErrorInvoice: '',
                sendFromFirstnameErrorEstimate: '',
                sendFromEmailIdErrorEstimate: '',
                replyToFirstnameErrorEstimate: '',
                replyToEmailIdErrorEstimate: '',
                bccErrorTicket: '',
                bccErrorInvoice: '',
                bccErrorEstimate: ''
            }
        }
    }

    async getEmailData() {
        const response = await apiservices.getEmailLookUp();
        const finalState: { [key: string]: any } = {
                ticketModule: {},
                invoiceModule: {},
                estimateModule: {},
        };
        const moduleMap: { [key: number]: string } = {
            6: 'ticketModule',
            7: 'invoiceModule',
            8: 'estimateModule'
        };

        if (Array.isArray(response)) {
            response.forEach((module: any) => {
                const moduleId = module?.moduleId?.id ?? module?.moduleId;
                const key = moduleMap[moduleId as number];
                if (!key) return;
                if (CHECK_NON_EMPTY_DICTIONARY(module?.moduleId)) {
                    module.moduleId = module?.moduleId?.id;
                }
                finalState[key] = module;
            });
        }

        const domainToggle =
            finalState.ticketModule?.sendFromEmailId === 'tickets@transactions.smartserv.io';

        this.setState({
            ...finalState,
            domainToggle
        });
    }

    async componentDidMount() {
        const response = await companyApiServices.getCompanies();
        var comp: any = [];
        response.map((company: any) => {
            comp.push({
                'title': `${company.name} (${company.id})`,
                'value': company.id
            })
            if(company.id == MASTER_COMPANY){
                this.setState({
                    selectedItem: {
                        'title': `${company.name} (${company.id})`,
                        'value': company.id,
                    }
                })
            }
        });
        var resultArray = Object.keys(comp).map(function (compIndex) {
            let company = comp[compIndex];
            return company;
        });
        this.setState({
            companyList: resultArray,
        })
        this.onCompanySelect('', this.state.selectedItem);
    }

    domainHandler = () => {
        this.setState(prevState => ({
            domainToggle: !this.state.domainToggle,
            ticketModule: {
                ...prevState.ticketModule,
                sendFromEmailId: 'tickets@transactions.smartserv.io'
            },
            invoiceModule: {
                ...prevState.invoiceModule,
                sendFromEmailId: 'invoices@transactions.smartserv.io'
            },
            estimateModule: {
                ...prevState.estimateModule,
                sendFromEmailId: 'estimates@transactions.smartserv.io'
            }
        }))
    }

    validate = () => {
        const emailRegexp = /[A-Z0-9._%+-]+@[A-Z0-9.-]+.[A-Z]{2,4}$/i;
        let { ticketModule } = this.state;
        let { invoiceModule } = this.state;
        let { estimateModule } = this.state;
        let response = false;
        //Ticket Module Validations
        if (ticketModule.sendFromFirstname === '' ||
            ticketModule.sendFromFirstname === null ||
            ticketModule.sendFromFirstname === undefined) {
            this.setState(prevState => ({
                errors: {
                    ...prevState.errors,
                    sendFromFirstnameErrorTicket: 'Send From Firstname is required.'
                }
            }))
            response = true;
        } else {
            this.setState(prevState => ({
                errors: {
                    ...prevState.errors,
                    sendFromFirstnameErrorTicket: ''
                }
            }))
        }
        if (ticketModule.sendFromEmailId === '' ||
            ticketModule.sendFromEmailId === null ||
            ticketModule.sendFromEmailId === undefined) {
            this.setState(prevState => ({
                errors: {
                    ...prevState.errors,
                    sendFromEmailIdErrorTicket: 'Send From Email ID is required.'
                }
            }))
            response = true;
        } else if (!emailRegexp.test(ticketModule.sendFromEmailId)) {
            this.setState(prevState => ({
                errors: {
                    ...prevState.errors,
                    sendFromEmailIdErrorTicket: 'Invalid Email ID.'
                }
            }))
            response = true;
        } else {
            this.setState(prevState => ({
                errors: {
                    ...prevState.errors,
                    sendFromEmailIdErrorTicket: ''
                }
            }))
        }
        if (ticketModule.replyToFirstname === '' ||
            ticketModule.replyToFirstname === null ||
            ticketModule.replyToFirstname === undefined) {
            this.setState(prevState => ({
                errors: {
                    ...prevState.errors,
                    replyToFirstnameErrorTicket: 'Reply To Firstname is required.'
                }
            }))
            response = true;
        } else {
            this.setState(prevState => ({
                errors: {
                    ...prevState.errors,
                    replyToFirstnameErrorTicket: ''
                }
            }))
        }
        if (ticketModule.replyToEmailId === '' ||
            ticketModule.replyToEmailId === null ||
            ticketModule.replyToEmailId === undefined) {
            this.setState(prevState => ({
                errors: {
                    ...prevState.errors,
                    replyToEmailIdErrorTicket: 'Reply To Email ID is required.'
                }
            }))
            response = true;
        } else if (!emailRegexp.test(ticketModule.replyToEmailId)) {
            this.setState(prevState => ({
                errors: {
                    ...prevState.errors,
                    replyToEmailIdErrorTicket: 'Invalid Email ID.'
                }
            }))
            response = true;
        } else {
            this.setState(prevState => ({
                errors: {
                    ...prevState.errors,
                    replyToEmailIdErrorTicket: ''
                }
            }))
        }
        if (/\s/.test(ticketModule.bccEmailId)) {
            this.setState(prevState => ({
                errors: {
                    ...prevState.errors,
                    bccErrorTicket: 'Remove spaces.'
                }
            }))
            response = true;
        } else {
            this.setState(prevState => ({
                errors: {
                    ...prevState.errors,
                    bccErrorTicket: ''
                }
            }))
        }

        //Invoice Module Validations
        if (invoiceModule.sendFromFirstname === '' ||
            invoiceModule.sendFromFirstname === null ||
            invoiceModule.sendFromFirstname === undefined) {
            this.setState(prevState => ({
                errors: {
                    ...prevState.errors,
                    sendFromFirstnameErrorInvoice: 'Send From Firstname is required.'
                }
            }))
            response = true;
        } else {
            this.setState(prevState => ({
                errors: {
                    ...prevState.errors,
                    sendFromFirstnameErrorInvoice: ''
                }
            }))
        }
        if (invoiceModule.sendFromEmailId === '' ||
            invoiceModule.sendFromEmailId === null ||
            invoiceModule.sendFromEmailId === undefined) {
            this.setState(prevState => ({
                errors: {
                    ...prevState.errors,
                    sendFromEmailIdErrorInvoice: 'Send From Email ID is required.'
                }
            }))
            response = true;
        } else if (!emailRegexp.test(invoiceModule.sendFromEmailId)) {
            this.setState(prevState => ({
                errors: {
                    ...prevState.errors,
                    sendFromEmailIdErrorInvoice: 'Invalid Email ID.'
                }
            }))
            response = true;
        } else {
            this.setState(prevState => ({
                errors: {
                    ...prevState.errors,
                    sendFromEmailIdErrorInvoice: ''
                }
            }))
        }
        if (invoiceModule.replyToFirstname === '' ||
            invoiceModule.replyToFirstname === null ||
            invoiceModule.replyToFirstname === undefined) {
            this.setState(prevState => ({
                errors: {
                    ...prevState.errors,
                    replyToFirstnameErrorInvoice: 'Reply To Firstname is required.'
                }
            }))
            response = true;
        } else {
            this.setState(prevState => ({
                errors: {
                    ...prevState.errors,
                    replyToFirstnameErrorInvoice: ''
                }
            }))
        }
        if (invoiceModule.replyToEmailId === '' ||
            invoiceModule.replyToEmailId === null ||
            invoiceModule.replyToEmailId === undefined) {
            this.setState(prevState => ({
                errors: {
                    ...prevState.errors,
                    replyToEmailIdErrorInvoice: 'Reply To Email ID is required.'
                }
            }))
            response = true;
        } else if (!emailRegexp.test(invoiceModule.replyToEmailId)) {
            this.setState(prevState => ({
                errors: {
                    ...prevState.errors,
                    sendFromEmailIdErrorInvoice: 'Invalid Email ID.'
                }
            }))
            response = true;
        } else {
            this.setState(prevState => ({
                errors: {
                    ...prevState.errors,
                    replyToEmailIdErrorInvoice: ''
                }
            }))
        }
        if (/\s/.test(invoiceModule.bccEmailId)) {
            this.setState(prevState => ({
                errors: {
                    ...prevState.errors,
                    bccErrorInvoice: 'Remove spaces.'
                }
            }))
            response = true;
        } else {
            this.setState(prevState => ({
                errors: {
                    ...prevState.errors,
                    bccErrorInvoice: ''
                }
            }))
        }

        //Estimate Module Validations
        if (estimateModule.sendFromFirstname === '' ||
            estimateModule.sendFromFirstname === null ||
            estimateModule.sendFromFirstname === undefined) {
            this.setState(prevState => ({
                errors: {
                    ...prevState.errors,
                    sendFromFirstnameErrorEstimate: 'Send From Firstname is required.'
                }
            }))
            response = true;
        } else {
            this.setState(prevState => ({
                errors: {
                    ...prevState.errors,
                    sendFromFirstnameErrorEstimate: ''
                }
            }))
        }
        if (estimateModule.sendFromEmailId === '' ||
            estimateModule.sendFromEmailId === null ||
            estimateModule.sendFromEmailId === undefined) {
            this.setState(prevState => ({
                errors: {
                    ...prevState.errors,
                    sendFromEmailIdErrorEstimate: 'Send From Email ID is required.'
                }
            }))
            response = true;
        } else if (!emailRegexp.test(estimateModule.sendFromEmailId)) {
            this.setState(prevState => ({
                errors: {
                    ...prevState.errors,
                    sendFromEmailIdErrorEstimate: 'Invalid Email ID.'
                }
            }))
            response = true;
        } else {
            this.setState(prevState => ({
                errors: {
                    ...prevState.errors,
                    sendFromEmailIdErrorEstimate: ''
                }
            }))
        }
        if (estimateModule.replyToFirstname === '' ||
            estimateModule.replyToFirstname === null ||
            estimateModule.replyToFirstname === undefined) {
            this.setState(prevState => ({
                errors: {
                    ...prevState.errors,
                    replyToFirstnameErrorEstimate: 'Reply To Firstname is required.'
                }
            }))
            response = true;
        } else {
            this.setState(prevState => ({
                errors: {
                    ...prevState.errors,
                    replyToFirstnameErrorEstimate: ''
                }
            }))
        }
        if (estimateModule.replyToEmailId === '' ||
            estimateModule.replyToEmailId === null ||
            estimateModule.replyToEmailId === undefined) {
            this.setState(prevState => ({
                errors: {
                    ...prevState.errors,
                    replyToEmailIdErrorEstimate: 'Reply To Email ID is required.'
                }
            }))
            response = true;
        } else if (!emailRegexp.test(estimateModule.replyToEmailId)) {
            this.setState(prevState => ({
                errors: {
                    ...prevState.errors,
                    sendFromEmailIdErrorEstimate: 'Invalid Email ID.'
                }
            }))
            response = true;
        } else {
            this.setState(prevState => ({
                errors: {
                    ...prevState.errors,
                    replyToEmailIdErrorEstimate: ''
                }
            }))
        }
        if (/\s/.test(estimateModule.bccEmailId)) {
            this.setState(prevState => ({
                errors: {
                    ...prevState.errors,
                    bccErrorEstimate: 'Remove spaces.'
                }
            }))
            response = true;
        } else {
            this.setState(prevState => ({
                errors: {
                    ...prevState.errors,
                    bccErrorEstimate: ''
                }
            }))
        }
        return response;
    }

    onSubmit = async () => {
        let error = this.validate();
        if (!error) {
            var data = {}
            data = {
                0: this.state.ticketModule,
                1: this.state.invoiceModule,
                2: this.state.estimateModule
            }
            let selectedCompanyId = localStorage.getItem('selectedCompanyId');
            let companyId = selectedCompanyId ? selectedCompanyId : localStorage.getItem('company-id');
            let api = new EmailApi();
            let response = await api.putEmail(companyId, data);
            if (response && response[0] && response[0].id) {
                this.setState({
                    snackBar: 'success',
                    pageResponse: "Updated Successfully."
                })
            } else {
                let msg;
                if(response && response.message && response.description) {
                    msg = `Update Failed: ${response.message} - ${response.description}`
                } else {
                    msg = `Update Failed.`
                }
                this.setState({
                    snackBar: 'error',
                    pageResponse: msg
                })
            }
        }
    }

    async onCompanySelect(e: any, value: any) {
        if (value) {
            const supportUser: any = await companyApiServices.getSupportUserForCompany(value.value) || {};
            console.log(supportUser);

            localStorage.setItem(
                'selectedCompanyDisplay', value.title
            );
            localStorage.setItem(
                'selectedCompanyId', value.value
            );
            localStorage.setItem(
                'supportUserIdOfSelectedCompany', supportUser.id
            );
            localStorage.setItem(
                'SupportUserDetailsOfSelectedCompany', supportUser
            );
            const googleTokenId = localStorage.getItem("google-token");
            const selectedCompanyId = localStorage.getItem("selectedCompanyId");
            const params = {
                googleTokenId: googleTokenId,
                selectedCompanyId: selectedCompanyId,
                supportUserId: supportUser.id
            }
            const response = await companyApiServices.auth(params);
            localStorage.setItem(
                'access-token', response.accessToken
            );
            localStorage.setItem(
                'company-id', value.value
            );
            localStorage.setItem(
                'user-id', supportUser.id
            );
            this.setState({
                selectedItem: {
                    'title': value.title,
                    'value': value.value
                },
                ticketModule: {},
                invoiceModule: {},
                estimateModule: {},
                domainToggle: false
            }, () => {
                value = this.state.selectedItem
            })
            this.getEmailData()
        }
    }

    render() {
        return (
            <div>
                <SRCards />
                <Container>
                <Autocomplete
                    id="combo-box-demo"
                    options={this.state.companyList}
                    getOptionLabel={
                        (option: any) => option.title
                    }
                    getOptionSelected={
                        (option, value) => option.title === value.title
                    }
                    onChange={(e, value) => {
                        this.onCompanySelect(e, value)
                    }}
                    value={this.state.selectedItem}
                    renderInput={(params) =>
                        <TextField {...params}
                            placeholder="Select Company"
                            variant="outlined" />}
                />
                    <br/><br/>
                    <Snackbar
                        open={this.state.snackBar === '' ? false : true}
                        anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'right',
                        }}
                        autoHideDuration={6000}
                        onClose={() => {
                            this.setState({
                                snackBar: ''
                            })
                        }}
                    >
                        <Alert
                            severity={this.state.snackBar}
                            onClose={() => {
                                this.setState({
                                    snackBar: ''
                                })
                            }}
                        >
                            {this.state.pageResponse}
                        </Alert>
                    </Snackbar>
                    
                    <FormControlLabel
                        style={{
                            padding: 16
                        }}
                        control={
                            <Switch
                                checked={this.state.domainToggle}
                                onChange={(e: any) => this.domainHandler()}
                            />
                        }
                        label="Use SmartServ Domain"
                    />
                    <Button
                        variant="outlined"
                        onClick={() => {
                            this.onSubmit()
                        }}
                    >
                        Submit
                </Button>
                    <Paper
                        style={{
                            padding: 16,
                            margin: 16
                        }}
                        elevation={1}
                    >
                        <Typography>Ticket Module</Typography>
                        <Tooltip
                            title={
                                <React.Fragment>
                                    <Typography>
                                        {`Send From Firstname, 
                                        Send From Email ID and 
                                        Reply To Email ID should not be empty`}
                                    </Typography>
                                </React.Fragment>
                            }>
                            <IconButton color='inherit'>
                                <InfoIcon />
                            </IconButton>
                        </Tooltip>
                        <Grid container spacing={10} style={{ padding: 20 }}>
                            <Grid item xs={4}>
                                <TextField
                                    style={{
                                        width: 300
                                    }}
                                    required
                                    error={
                                        this.state.errors.sendFromFirstnameErrorTicket === '' ?
                                            false :
                                            true
                                    }
                                    helperText={
                                        this.state.errors.sendFromFirstnameErrorTicket
                                    }
                                    label='Send From First Name'
                                    onChange={(e) => {
                                        this.setState(prevState => ({
                                            ticketModule: {
                                                ...prevState.ticketModule,
                                                sendFromFirstname: e.target.value
                                            }
                                        }))
                                    }}
                                    id='send-from'
                                    value={
                                        this.state.ticketModule.sendFromFirstname ?
                                            this.state.ticketModule.sendFromFirstname : ''
                                    }
                                />
                            </Grid>
                            <Grid item xs={4}>
                                <TextField
                                    style={{ width: 300 }}
                                    label='Send From Last Name'
                                    onChange={(e) => {
                                        this.setState(prevState => ({
                                            ticketModule: {
                                                ...prevState.ticketModule,
                                                sendFromLastname: e.target.value
                                            }
                                        }))
                                    }}
                                    id='send-from'
                                    value={
                                        this.state.ticketModule.sendFromLastname ?
                                            this.state.ticketModule.sendFromLastname : ''
                                    }
                                />
                            </Grid>
                            <Grid item xs={4}>
                                <TextField
                                    style={{
                                        width: 300
                                    }}
                                    required
                                    error={
                                        this.state.errors.sendFromEmailIdErrorTicket === '' ?
                                            false :
                                            true
                                    }
                                    helperText={this.state.errors.sendFromEmailIdErrorTicket}
                                    label='Send From Email ID'
                                    onChange={(e) => {
                                        this.setState(prevState => ({
                                            ticketModule: {
                                                ...prevState.ticketModule,
                                                sendFromEmailId: e.target.value
                                            }
                                        }))
                                    }}
                                    disabled={this.state.domainToggle}
                                    id='send-from'
                                    value={
                                        this.state.domainToggle ?
                                            'tickets@transactions.smartserv.io' :
                                            this.state.ticketModule.sendFromEmailId ?
                                                this.state.ticketModule.sendFromEmailId : ''
                                    }
                                />
                            </Grid>
                        </Grid>
                        <Grid container spacing={10} style={{ padding: 20 }}>
                            <Grid item xs={4}>
                                <TextField
                                    style={{ width: 300 }}
                                    required
                                    error={
                                        this.state.errors.replyToFirstnameErrorTicket === '' ?
                                            false :
                                            true
                                    }
                                    helperText={
                                        this.state.errors.replyToFirstnameErrorTicket
                                    }
                                    label='Reply To First Name'
                                    onChange={(e) => {
                                        this.setState(prevState => ({
                                            ticketModule: {
                                                ...prevState.ticketModule,
                                                replyToFirstname: e.target.value
                                            }
                                        }))
                                    }}
                                    id='send-from'

                                    value={
                                        this.state.ticketModule.replyToFirstname ?
                                            this.state.ticketModule.replyToFirstname : ''
                                    }
                                />
                            </Grid>
                            <Grid item xs={4}>
                                <TextField
                                    style={{ width: 300 }}
                                    label='Reply To Last Name'
                                    onChange={(e) => {
                                        this.setState(prevState => ({
                                            ticketModule: {
                                                ...prevState.ticketModule,
                                                replyToLastname: e.target.value
                                            }
                                        }))
                                    }}
                                    id='send-from'
                                    value={
                                        this.state.ticketModule.replyToLastname ?
                                            this.state.ticketModule.replyToLastname : ''
                                    }
                                />
                            </Grid>
                            <Grid item xs={4}>
                                <TextField
                                    style={{
                                        width: 300
                                    }}
                                    required
                                    error={
                                        this.state.errors.replyToEmailIdErrorTicket === '' ?
                                            false :
                                            true
                                    }
                                    helperText={
                                        this.state.errors.replyToEmailIdErrorTicket
                                    }
                                    label='Reply To Email ID'
                                    onChange={(e) => {
                                        this.setState(prevState => ({
                                            ticketModule: {
                                                ...prevState.ticketModule,
                                                replyToEmailId: e.target.value
                                            }
                                        }))
                                    }}
                                    id='send-from'
                                    value={
                                        this.state.ticketModule.replyToEmailId ?
                                            this.state.ticketModule.replyToEmailId : ''
                                    }
                                />
                            </Grid>
                        </Grid>
                        <Grid container spacing={10} style={{ padding: 20 }}>
                            <Grid item xs={11}>
                                <TextField
                                    fullWidth
                                    error={
                                        this.state.errors.bccErrorTicket === '' ?
                                            false :
                                            true
                                    }
                                    helperText={
                                        this.state.errors.bccErrorTicket
                                    }
                                    onChange={(e) => {
                                        let value: any = [];
                                        if (e.target.value.includes(',')) {
                                            value = e.target.value.split(',')
                                        }
                                        else {
                                            value.push(e.target.value)
                                        }
                                        this.setState(prevState => ({
                                            ticketModule: {
                                                ...prevState.ticketModule,
                                                bccEmailId: value
                                            }
                                        }))
                                    }}
                                    value={
                                        this.state.ticketModule.bccEmailId ?
                                            this.state.ticketModule.bccEmailId :
                                            ''
                                    }
                                    id='bcc'
                                    label='BCC'
                                />
                            </Grid>
                            <Grid item xs={1}>
                                <Tooltip
                                    title={
                                        <React.Fragment>
                                            <Typography>
                                                {`Use a comma to separate multiple email ids in bcc. 
                                                    Don't use spaces. 
                                                    For eg. abc@xyz.com,def@xyz.com,ghi@xyz.com`}
                                            </Typography>
                                        </React.Fragment>
                                    }>
                                    <InfoIcon />
                                </Tooltip>
                            </Grid>
                        </Grid>
                    </Paper>
                    <Paper style={{ padding: 16, margin: 16 }} elevation={1}>
                        <Typography>Invoice Module</Typography>
                        <Tooltip
                            title={
                                <React.Fragment>
                                    <Typography>
                                        {`Send From Firstname, 
                                        Send From Email ID and 
                                        Reply To Email ID should not be empty`}
                                    </Typography>
                                </React.Fragment>
                            }>
                            <IconButton color='inherit'>
                                <InfoIcon />
                            </IconButton>
                        </Tooltip>
                        <Grid container spacing={10} style={{ padding: 20 }}>
                            <Grid item xs={4}>
                                <TextField
                                    style={{
                                        width: 300
                                    }}
                                    required
                                    error={
                                        this.state.errors.sendFromFirstnameErrorInvoice === '' ?
                                            false :
                                            true
                                    }
                                    helperText={
                                        this.state.errors.sendFromFirstnameErrorInvoice
                                    }
                                    label='Send From First Name'
                                    onChange={(e) => {
                                        this.setState(prevState => ({
                                            invoiceModule: {
                                                ...prevState.invoiceModule,
                                                sendFromFirstname: e.target.value
                                            }
                                        }))
                                    }}
                                    id='send-from'
                                    value={
                                        this.state.invoiceModule.sendFromFirstname ?
                                            this.state.invoiceModule.sendFromFirstname : ''
                                    }
                                />
                            </Grid>
                            <Grid item xs={4}>
                                <TextField
                                    style={{
                                        width: 300
                                    }}
                                    label='Send From Last Name'
                                    onChange={(e) => {
                                        this.setState(prevState => ({
                                            invoiceModule: {
                                                ...prevState.invoiceModule,
                                                sendFromLastname: e.target.value
                                            }
                                        }))
                                    }}
                                    id='send-from'
                                    value={
                                        this.state.invoiceModule.sendFromLastname ?
                                            this.state.invoiceModule.sendFromLastname : ''
                                    }
                                />
                            </Grid>
                            <Grid item xs={4}>
                                <TextField
                                    style={{
                                        width: 300
                                    }}
                                    required
                                    error={
                                        this.state.errors.sendFromEmailIdErrorInvoice === '' ?
                                            false :
                                            true
                                    }
                                    helperText={
                                        this.state.errors.sendFromEmailIdErrorInvoice
                                    }
                                    label='Send From Email ID'
                                    onChange={(e) => {
                                        this.setState(prevState => ({
                                            invoiceModule: {
                                                ...prevState.invoiceModule,
                                                sendFromEmailId: e.target.value
                                            }
                                        }))
                                    }}
                                    disabled={this.state.domainToggle}
                                    id='send-from'
                                    value={
                                        this.state.domainToggle ?
                                            'invoices@transactions.smartserv.io' :
                                            this.state.invoiceModule.sendFromEmailId ?
                                                this.state.invoiceModule.sendFromEmailId : ''
                                    }
                                />
                            </Grid>
                        </Grid>
                        <Grid container spacing={10} style={{ padding: 20 }}>
                            <Grid item xs={4}>
                                <TextField
                                    style={{
                                        width: 300
                                    }}
                                    required
                                    error={
                                        this.state.errors.replyToFirstnameErrorInvoice === '' ?
                                            false :
                                            true
                                    }
                                    helperText={
                                        this.state.errors.replyToFirstnameErrorInvoice
                                    }
                                    label='Reply To First Name'
                                    onChange={(e) => {
                                        this.setState(prevState => ({
                                            invoiceModule: {
                                                ...prevState.invoiceModule,
                                                replyToFirstname: e.target.value
                                            }
                                        }))
                                    }}
                                    id='send-from'
                                    value={
                                        this.state.invoiceModule.replyToFirstname ?
                                            this.state.invoiceModule.replyToFirstname : ''
                                    }
                                />
                            </Grid>
                            <Grid item xs={4}>
                                <TextField
                                    style={{ width: 300 }}
                                    label='Reply To Last Name'
                                    onChange={(e) => {
                                        this.setState(prevState => ({
                                            invoiceModule: {
                                                ...prevState.invoiceModule,
                                                replyToLastname: e.target.value
                                            }
                                        }))
                                    }}
                                    id='send-from'
                                    value={
                                        this.state.invoiceModule.replyToLastname ?
                                            this.state.invoiceModule.replyToLastname : ''
                                    }
                                />
                            </Grid>
                            <Grid item xs={4}>
                                <TextField
                                    style={{
                                        width: 300
                                    }}
                                    required
                                    error={
                                        this.state.errors.replyToEmailIdErrorInvoice === '' ?
                                            false :
                                            true
                                    }
                                    helperText={this.state.errors.replyToEmailIdErrorInvoice}
                                    label='Reply To Email ID'
                                    onChange={(e) => {
                                        this.setState(prevState => ({
                                            invoiceModule: {
                                                ...prevState.invoiceModule,
                                                replyToEmailId: e.target.value
                                            }
                                        }))
                                    }}
                                    id='send-from'
                                    value={
                                        this.state.invoiceModule.replyToEmailId ?
                                            this.state.invoiceModule.replyToEmailId : ''
                                    }
                                />
                            </Grid>
                        </Grid>
                        <Grid container spacing={10} style={{ padding: 20 }}>
                            <Grid item xs={11}>
                                <TextField
                                    fullWidth
                                    error={
                                        this.state.errors.bccErrorInvoice === '' ?
                                            false :
                                            true
                                    }
                                    helperText={
                                        this.state.errors.bccErrorInvoice
                                    }
                                    onChange={(e) => {
                                        let value: any = [];
                                        if (e.target.value.includes(',')) {
                                            value = e.target.value.split(',')
                                        }
                                        else {
                                            value.push(e.target.value)
                                        }
                                        this.setState(prevState => ({
                                            invoiceModule: {
                                                ...prevState.invoiceModule,
                                                bccEmailId: value
                                            }
                                        }))
                                    }}
                                    value={
                                        this.state.invoiceModule.bccEmailId ?
                                            this.state.invoiceModule.bccEmailId :
                                            ''
                                    }
                                    id='bcc'
                                    label='BCC'
                                />
                            </Grid>
                            <Grid item xs={1}>
                                <Tooltip
                                    title={
                                        <React.Fragment>
                                            <Typography>
                                                {`Use a comma to separate multiple email ids in bcc. 
                                                Don't use spaces. 
                                                For eg. abc@xyz.com,def@xyz.com,ghi@xyz.com`}
                                            </Typography>
                                        </React.Fragment>
                                    }>
                                    <InfoIcon />
                                </Tooltip>
                            </Grid>
                        </Grid>
                    </Paper>
                    <Paper style={{ padding: 16, margin: 16 }} elevation={1}>
                        <Typography>Estimate Module</Typography>
                        <Tooltip
                            title={
                                <React.Fragment>
                                    <Typography>
                                        {`Send From Firstname, 
                                        Send From Email ID and 
                                        Reply To Email ID should not be empty`}
                                    </Typography>
                                </React.Fragment>
                            }>
                            <IconButton color='inherit'>
                                <InfoIcon />
                            </IconButton>
                        </Tooltip>
                        <Grid container spacing={10} style={{ padding: 20 }}>
                            <Grid item xs={4}>
                                <TextField
                                    style={{
                                        width: 300
                                    }}
                                    required
                                    error={
                                        this.state.errors.sendFromFirstnameErrorEstimate === '' ?
                                            false :
                                            true
                                    }
                                    helperText={
                                        this.state.errors.sendFromFirstnameErrorEstimate
                                    }
                                    label='Send From First Name'
                                    onChange={(e) => {
                                        this.setState(prevState => ({
                                            estimateModule: {
                                                ...prevState.estimateModule,
                                                sendFromFirstname: e.target.value
                                            }
                                        }))
                                    }}
                                    id='send-from'
                                    value={
                                        this.state.estimateModule.sendFromFirstname ?
                                            this.state.estimateModule.sendFromFirstname : ''
                                    }
                                />
                            </Grid>
                            <Grid item xs={4}>
                                <TextField
                                    style={{
                                        width: 300
                                    }}
                                    label='Send From Last Name'
                                    onChange={(e) => {
                                        this.setState(prevState => ({
                                            estimateModule: {
                                                ...prevState.estimateModule,
                                                sendFromLastname: e.target.value
                                            }
                                        }))
                                    }}
                                    id='send-from'
                                    value={
                                        this.state.estimateModule.sendFromLastname ?
                                            this.state.estimateModule.sendFromLastname : ''
                                    }
                                />
                            </Grid>
                            <Grid item xs={4}>
                                <TextField
                                    style={{
                                        width: 300
                                    }}
                                    required
                                    error={
                                        this.state.errors.sendFromEmailIdErrorEstimate === '' ?
                                            false :
                                            true
                                    }
                                    helperText={
                                        this.state.errors.sendFromEmailIdErrorEstimate
                                    }
                                    label='Send From Email ID'
                                    onChange={(e) => {
                                        this.setState(prevState => ({
                                            estimateModule: {
                                                ...prevState.estimateModule,
                                                sendFromEmailId: e.target.value
                                            }
                                        }))
                                    }}
                                    disabled={this.state.domainToggle}
                                    id='send-from'
                                    value={
                                        this.state.domainToggle ?
                                            'estimates@transactions.smartserv.io' :
                                            this.state.estimateModule.sendFromEmailId ?
                                                this.state.estimateModule.sendFromEmailId : ''
                                    }
                                />
                            </Grid>
                        </Grid>
                        <Grid container spacing={10} style={{ padding: 20 }}>
                            <Grid item xs={4}>
                                <TextField
                                    style={{
                                        width: 300
                                    }}
                                    required
                                    error={
                                        this.state.errors.replyToFirstnameErrorEstimate === '' ?
                                            false :
                                            true
                                    }
                                    helperText={
                                        this.state.errors.replyToFirstnameErrorEstimate
                                    }
                                    label='Reply To First Name'
                                    onChange={(e) => {
                                        this.setState(prevState => ({
                                            estimateModule: {
                                                ...prevState.estimateModule,
                                                replyToFirstname: e.target.value
                                            }
                                        }))
                                    }}
                                    id='send-from'
                                    value={
                                        this.state.estimateModule.replyToFirstname ?
                                            this.state.estimateModule.replyToFirstname : ''
                                    }
                                />
                            </Grid>
                            <Grid item xs={4}>
                                <TextField
                                    style={{
                                        width: 300
                                    }}
                                    label='Reply To Last Name'
                                    onChange={(e) => {
                                        this.setState(prevState => ({
                                            estimateModule: {
                                                ...prevState.estimateModule,
                                                replyToLastname: e.target.value
                                            }
                                        }))
                                    }}
                                    id='send-from'
                                    value={
                                        this.state.estimateModule.replyToLastname ?
                                            this.state.estimateModule.replyToLastname : ''
                                    }
                                />
                            </Grid>
                            <Grid item xs={4}>
                                <TextField
                                    style={{
                                        width: 300
                                    }}
                                    required
                                    error={
                                        this.state.errors.replyToEmailIdErrorEstimate === '' ?
                                            false :
                                            true
                                    }
                                    helperText={
                                        this.state.errors.replyToEmailIdErrorEstimate
                                    }
                                    label='Reply To Email ID'
                                    onChange={(e) => {
                                        this.setState(prevState => ({
                                            estimateModule: {
                                                ...prevState.estimateModule,
                                                replyToEmailId: e.target.value
                                            }
                                        }))
                                    }}
                                    id='send-from'
                                    value={
                                        this.state.estimateModule.replyToEmailId ?
                                            this.state.estimateModule.replyToEmailId : ''
                                    }
                                />
                            </Grid>
                        </Grid>
                        <Grid container spacing={10} style={{ padding: 20 }}>
                            <Grid item xs={11}>
                                <TextField
                                    fullWidth
                                    error={
                                        this.state.errors.bccErrorEstimate === '' ?
                                            false :
                                            true
                                    }
                                    helperText={
                                        this.state.errors.bccErrorEstimate
                                    }
                                    onChange={(e) => {
                                        let value: any = [];
                                        if (e.target.value.includes(',')) {
                                            value = e.target.value.split(',')
                                        }
                                        else {
                                            value.push(e.target.value)
                                        }
                                        this.setState(prevState => ({
                                            estimateModule: {
                                                ...prevState.estimateModule,
                                                bccEmailId: value
                                            }
                                        }))
                                    }}
                                    value={
                                        this.state.estimateModule.bccEmailId ?
                                            this.state.estimateModule.bccEmailId :
                                            ''
                                    }
                                    id='bcc'
                                    label='BCC'
                                />
                            </Grid>
                            <Grid item xs={1}>
                                <Tooltip
                                    title={
                                        <React.Fragment>
                                            <Typography>
                                                {`Use a comma to separate multiple email ids in bcc. 
                                                Don't use spaces. 
                                                For eg. abc@xyz.com,def@xyz.com,ghi@xyz.com`}
                                            </Typography>
                                        </React.Fragment>
                                    }>
                                    <InfoIcon />
                                </Tooltip>
                            </Grid>
                        </Grid>
                    </Paper>
                </Container>
            </div>
        )
    }
}

export default EmailDomainChange;
